import clsx from 'clsx';
import { useCountdown } from 'hooks/draw/useCountdown';
import { observer } from 'mobx-react-lite';
import { Fragment } from 'react';
import styles from './EnterHeaderDrawCountdown.module.css';

interface EnterHeaderDrawCountdownProps {
  targetDate: Date | undefined | null;
  variant?: undefined | 'V2' | 'V3';
}

const EnterHeaderDrawCountdown = observer(
  ({ targetDate, variant }: EnterHeaderDrawCountdownProps) => {
    const { paddedTimeLeft, domProps } = useCountdown(targetDate);

    const blocks = [
      { value: paddedTimeLeft.days, label: 'Days' },
      { value: paddedTimeLeft.hours, label: 'Hours' },
      { value: paddedTimeLeft.minutes, label: 'Mins' },
      { value: paddedTimeLeft.seconds, label: 'Secs' },
    ];

    return (
      <div
        className={clsx(
          styles.container,
          variant && styles[`variant__${variant}`],
        )}
        {...domProps}
      >
        <span className="daymadeTypographyXS">Next draw in:</span>
        <div className={clsx(styles.countdown, 'daymadeTypographySRegular')}>
          {blocks.map((block, i) => (
            <Fragment key={i}>
              {i > 0 && <span className={styles.separator}>:</span>}
              <div className={styles.timeBlock}>
                <div>{block.value}</div>
                <span className={clsx(styles.label, 'daymadeTypographyXS')}>
                  {block.label}
                </span>
              </div>
            </Fragment>
          ))}
        </div>
      </div>
    );
  },
);

export default EnterHeaderDrawCountdown;
